const dataWardens = [
	{
		name: "Basant Yadav",
		designation: "Chief Warden",
		img: "chief_warden.jpeg",
		phone: "",
		email: "cw-jawaharbhawan@iitr.ac.in",
	},
	{
		name: "Nitin Khandelwal",
		designation: "Mess Warden",
		img: "nitin_mess_warden.jpeg",
		phone: "",
		email: "nitin.khandelwal@hy.iitr.ac.in",
	},
	{
		name: "Hemant Kumar",
		designation: "Wellness Warden",
		img: "wellness_warden.jpeg",
		phone: "+91 84393 97365",
		email: " hemant@ce.iitr.ac.in",
	},
	{
		name: "Ram Santran",
		designation: "Assistant Warden",
		img: "assistant_warden.jpeg",
		phone: "96955 92481",
		email: "",
	},
	{
		name: "Chunendra Kumar Singh Chaudhary",
		designation: "Assistant Warden",
		img: "assistant_warden2.jpeg",
		phone: "+91 83869 53618",
		email: "",
	},
    {
		name: "Ashish Kumar Dhingya",
		designation: "Supervisor",
		img: "supervisor.jpeg",
		phone: "+91 70606 16348",
		email: "jawaharbhawan@iitr.ac.in",
	},
    {
		name: "Pervez Chauhan",
		designation: "Mess manager ",
		img: "mess_manager.jpeg",
		phone: "+91 96346 67374",
		email: "jawaharbhawanmess@iitr.ac.in",
	}
];

const dataSecy = [
	{
		name: "Rahul Lamba",
		designation: "Bhawan Secretary",
		img: "rahul_bhawan.jpeg",
		phone: "94670 92080",
		email: " rahul3@ce.iitr.ac.in",
	},
	{
		name: "Harrish Bansal",
		designation: "Technical Secretary",
		img: "dj_tech.jpeg",
		phone: "94638 90600",
		email: "harrish_b@me.iitr.ac.in",
	},
	{
		name: "Krish Garg",
		designation: "Sports Secretary",
		img: "krish_sports.jpeg",
		phone: "",
		email: "krish_g@ph.iitr.ac.in",
	},
    {
		name: "Owais Raza Pathan",
		designation: "Wellness Secretary",
		img: "owais_wellness.jpeg",
		phone: "+91 93368 11681",
		email: "aryan_s@ee.iitr.ac.in",
	},
	{
		name: "Kaushlandra Singh",
		designation: "Cultural Secretary",
		img: "kaush_cult.jpeg",
		phone: "",
		email: "kaushlandra_s@es.iitr.ac.in",
	},
	{
		name: "Ishan Jha",
		designation: "Maintenance Secretary",
		img: "ishan_maintain.jpeg",
		phone: "",
		email: "ishan_j@ar.iitr.ac.in",
	},
	
{
    name: "Hardik Goyal",
    designation: "Mess Secretary",
    img: "hardik_mess.jpeg", 
    phone: "",
    email: "hardik_g1@ce.iitr.ac.in",
},
]

export default dataWardens;
export {dataSecy};
